import { IBarcode } from '@app/models/barcode.interface';
import { IPicking } from '@app/models/picking.interface';
import { createAction, props } from '@ngrx/store';

export const loadPickings = createAction(
  '[Pickings] Load Pickings',
  props<any>()
);

export const loadPickingsSuccess = createAction(
  '[Pickings] Load Pickings Success',
  props<{ pickings: IPicking[], total: number }>()
);

export const loadPickingsFailure = createAction(
  '[Pickings] Load Pickings Failure',
  props<{ error: any }>()
);

export const filterByCategory = createAction(
  '[Pickings] Filter Pickings By Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByCategorySuccess = createAction(
  '[Pickings] Filter Pickings By Category Success',
  props<any>()
);

export const filterByCategoryFailure = createAction(
  '[Pickings] Filter Pickings By Category Failure',
  props<{ error: any }>()
);

export const savePicking = createAction(
  '[Pickings] Save Picking',
  props<{ form: any }>()
);

export const savePickingSuccess = createAction(
  '[Pickings] Save Picking Success',
  props<any>()
);

export const savePickingFailure = createAction(
  '[Pickings] Save Picking Failure',
  props<{ error: any}>()
);

export const updatePicking = createAction(
  '[Pickings] Update Picking',
  props<{ form: any }>()
);

export const updatePickingSuccess = createAction(
  '[Pickings] Update Picking Success',
  props<{ picking: any }>()
);

export const updatePickingFailure = createAction(
  '[Pickings] Update Picking Failure',
  props<{ error: any }>()
);

export const loadPicking = createAction(
  '[Pickings] Load Picking',
  props<{ productMovementHistoryID: any }>()
);

export const loadPickingSuccess = createAction(
  '[Pickings] Load Picking Success',
  props<{ picking: any }>()
);

export const loadPickingFailure = createAction(
  '[Pickings] Load Picking Failure',
  props<{ error: any }>()
);

export const saveOverride = createAction(
  '[Pickings] Save Override',
  props<{ form: any }>()
);

export const saveOverrideSuccess = createAction(
  '[Pickings] Save Override Success',
  props<any>()
);

export const saveOverrideFailure = createAction(
  '[Pickings] Save Override Failure',
  props<{ error: any }>()
);

export const filterByArea = createAction(
  '[Pickings] Filter Pickings By Area',
  props<{ prdAreaID: number, active: string, direction: string }>()
);

export const filterByAreaSuccess = createAction(
  '[Pickings] Filter Pickings By Area Success',
  props<any>()
);

export const filterByAreaFailure = createAction(
  '[Pickings] Filter Pickings By Area Failure',
  props<{ error: any }>()
);

export const search = createAction(
  '[Pickings] Search',
  props<{ query: string}>()
);

export const searchSuccess = createAction(
  '[Pickings] Search Success',
  props<{ pickings: IPicking[], total: number}>()
);

export const searchFailure = createAction(
  '[Pickings] Search Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Pickings] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Pickings] Reset Pagination'
);

export const resetPickings = createAction(
  '[Pickings] Reset Pickings'
);

export const incrementPageSuccess = createAction(
  '[Pickings] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Pickings] Decrement Pagination'
);

export const setBarcodeType = createAction(
  '[Pickings] Set Barcodes',
  props<{ data: any }>()
);

export const loadBarcodeType = createAction(
  '[Pickings] Load Barcodes',
  props<{ data: any }>()
);

export const setFilterType = createAction(
  '[Pickings] Set Filter Type',
  props<{ filterType: string, filterID: number }>()
);

export const setSelected = createAction(
  '[Pickings] Set Selected',
  props<{ selected: any }>()
);

export const setSort = createAction(
  '[Pickings] Set Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const resetPicking = createAction(
  '[Pickings] Reset Picking'
);

export const resetFilter = createAction(
  '[Pickings] Reset Filter'
)

export const setDeselected = createAction(
  '[Pickings] Set Deselected'
);

export const deletePickings = createAction(
  '[Pickings] Delete Pickings',
  props<any>()
);

export const deletePickingsSuccess = createAction(
  '[Pickings] Delete Pickings Success',
  props<any>()
);

export const deletePickingsFailure = createAction(
  '[Pickings] Delete Pickings Failure',
  props<{ error: any }>()
);

export const deletePicking = createAction(
  '[Pickings] Delete Picking',
  props<{productMovementHistoryID: number,reason:string }>()
);

export const deletePickingSuccess = createAction(
  '[Pickings] Delete Picking Success',
  props<any>()
);

export const deletePickingFailure = createAction(
  '[Pickings] Delete Picking Failure',
  props<{ error: any }>()
);

export const createBarcode = createAction(
  '[Pickings] Create Barcode',
  props<{barcodeData: string, productMovementHistoryID: number }>()
);

export const createBarcodeSuccess = createAction(
  '[Pickings] Create Barcode Success',
  props<any>()
);

export const createBarcodeFailure = createAction(
  '[Pickings] Create Barcode Failure',
  props<{ error: any }>()
);

export const setBarcodes = createAction(
  '[Pickings] Set Barcode',
  props<{barcodes: IBarcode[] }>()
);

export const setSelectedBarcode = createAction(
  '[Pickings] Set Selected Barcode',
  props<{ index: number }>()
)

export const deleteBarcode = createAction(
  '[Pickings] Delete Barcode',
  props<{barcodeID: number }>()
);

export const deleteBarcodeSuccess = createAction(
  '[Pickings] Delete Barcode Success',
  props<any>()
);

export const deleteBarcodeFailure = createAction(
  '[Pickings] Delete Barcode Failure',
  props<{ error: any }>()
);

export const exportPickings = createAction(
  '[Pickings] Export Pickings'
);

export const sortByCategory = createAction(
  '[Pickings] Sort By Category Pickings',
  props<{ active: string, direction:string, category: number }>()
);

export const sortByCategorySuccess = createAction(
  '[Pickings] Sort By Category Pickings Success',
  props<any>()
);

export const sortByCategoryFailure = createAction(
  '[Pickings] Sort By Category Pickings Failure',
  props<{ error: any }>()
);

export const setIsLoading = createAction(
  '[Pickings] Set Is Loading',
  props<{ isLoading: boolean }>()
);

